import { render, staticRenderFns } from "./aboutInvestCen.vue?vue&type=template&id=c0e9e558&scoped=true"
import script from "./aboutInvestCen.vue?vue&type=script&lang=js"
export * from "./aboutInvestCen.vue?vue&type=script&lang=js"
import style1 from "./aboutInvestCen.vue?vue&type=style&index=1&id=c0e9e558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e9e558",
  null
  
)

export default component.exports